import { EnumBasedItem, createEnumService } from "./base";

export enum TrainingContextType {
  INDIVIDUAL = "individual",
  AUTOMATIC = "automatic",
}

export class TrainingContext extends EnumBasedItem<TrainingContextType> {}

const trainingContextService = createEnumService(TrainingContextType, TrainingContext);
export default trainingContextService;
